/* global CONFIG */
// CONFIG may or may not be available. It's a JSON serialised value of the helm
// charts' {{ .Values.config.env }} and it's injected through a ConfigMap
// and loaded in index.html

const defaults = {
  // SRM_GATEWAY: 'https://integration.app.securityrisk.com',
  SRM_GATEWAY: 'http://localhost:5100',
  LEGAL_LINK: 'https://legal.securityrisk.com/',
  FCM_API_KEY: 'AIzaSyCwgAr5Qrnpfj-jdOY9ioUWlx9o-BtQm6E',
  FCM_AUTH_DOMAIN: 'sr-bruce.firebaseapp.com',
  FCM_DB_URL: 'https://sr-bruce.firebaseio.com',
  FCM_PROJECT_ID: 'sr-bruce',
  FCM_STORAGE_BUCKET: 'sr-bruce.appspot.com',
  FCM_APP_ID: '1:541543782993:web:8c8a7c1666c538d855b670',
  GOOGLE_API_KEY: 'AIzaSyCwgAr5Qrnpfj-jdOY9ioUWlx9o-BtQm6E', //development purpose
  SENTRY_IO_ID: 'https://xxxxx@sec-risk.io/41232323', // understanding what failed
  PUBLISHABLE_API_KEY: 'pk_test_QMkKCoY0q05UKgm60KMom7Zm009OfuNcuc', //publishable API key
  ASSET_BUCKET: 'https://storage.googleapis.com/srm_portal_assets-dev/', // path to portal asset on google storage
};

const INJECTED = typeof CONFIG === 'undefined' ? {} : CONFIG;

const mergeConfig = {
  ...defaults,
  ...INJECTED,
};

const Config = {
  sentryIoDsn: mergeConfig.SENTRY_IO_ID,
  googleApiKey: mergeConfig.GOOGLE_API_KEY,
  fcmApiKey: mergeConfig.FCM_API_KEY,
  authDomain: mergeConfig.FCM_AUTH_DOMAIN,
  dbUrl: mergeConfig.FCM_DB_URL,
  projectId: mergeConfig.FCM_PROJECT_ID,
  storageBucket: mergeConfig.FCM_STORAGE_BUCKET,
  senderId: mergeConfig.FCM_SENDER_ID,
  appId: mergeConfig.FCM_APP_ID,
  api: mergeConfig.SRM_GATEWAY,
  termLink: `${mergeConfig.LEGAL_LINK}/terms.html`,
  dataPolicyLink: `${mergeConfig.LEGAL_LINK}/data-policy.html`,
  stripePublishableKey: mergeConfig.PUBLISHABLE_API_KEY,
  assetBucket: mergeConfig.ASSET_BUCKET,
};

export default Config;
